import { FC } from 'react';

interface CalculatedCountProps {
	limit: number;
	page: number;
	nextPage: boolean;
	tasksCount?: number;
	outOfText: string;
}

export const CalculatedCount: FC<CalculatedCountProps> = ({ limit, page, nextPage, tasksCount = 0, outOfText }) => {
	const offset = limit * (page - 1);
	const start = offset + 1;
	const end = nextPage ? offset + limit : offset + tasksCount;
	const total = nextPage ? `${offset + limit}+` : offset + tasksCount;

	return (
		<div>{tasksCount ? `${start}-${end} ${outOfText} ${total}` : `${tasksCount} ${outOfText} ${tasksCount}`}</div>
	);
};
